import React from 'react'
import { Url } from '../../UrlServer'
import { formatUSD } from '../../../utils/formatter'
import { OrderItem as TOderItem } from '../../../redux/reducers/orderReducers'

interface OrderItemProps {
  item?: TOderItem
}

const OrderItem: React.FC<OrderItemProps> = ({ item }) => {
  return (
    <div className="__list-single" key={item?._id + '' + Math.random()}>
      <div className="__list-single-img">
        <img
          src={`${Url}/${item?.product?.image || ''}`}
          alt={item?.product?.image || ''}
        />
        <div className="__list-np">
          <p className="lname">
            {(item?.product?.name || '').length < 11
              ? item?.product?.name
              : `${item?.product?.name.substring(0, 8)}.`}
          </p>
          <span className="lprice">{formatUSD(item?.product?.price || 0)}</span>
        </div>
      </div>
      <div className="__list-qty">
        <p className="-qty">x {item?.quantity}</p>
        <p className="-qty-txt">Quantity</p>
      </div>
      <div className="__list--subtotal">
        <p className="--subtotal">
          {formatUSD((item?.product?.price || 0) * (item?.quantity || 0))}
        </p>
        <p className="-subtt-txt">Subtotal</p>
      </div>
    </div>
  )
}

export default OrderItem
